import { EcranAnalyse } from '@/components/analyse/ecran-analyse';
import { rechercheAnalyseSchema } from '@/lib/params-recherche';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/resultat/$id/analyse')({
  validateSearch: (recherche) => rechercheAnalyseSchema.parse(recherche),
  component: AnalysePage,
});

/** `/resultat/$id/analyse?noyau=&onglet=`: the tab and the noyau live in the URL. */
function AnalysePage() {
  const { id } = Route.useParams();
  const { noyau, onglet } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <EcranAnalyse
      key={id}
      id={id}
      noyau={noyau}
      onglet={onglet}
      onChangerOnglet={(suivant) => {
        void navigate({
          search: (precedent) => ({ ...precedent, onglet: suivant }),
          replace: true,
        });
      }}
    />
  );
}
